import type { TelehealthReportImage } from '@/api/print/types';

type ReportImagesGridProps = {
  images: TelehealthReportImage[];
  onImageLoad: () => void;
};

export function ReportImagesGrid({ images, onImageLoad }: ReportImagesGridProps) {
  // Separate images by eye side and label for the 2x2 grid
  const getImage = (eyeSide: string, label: string) =>
    images.find((img) => img.eye_side === eyeSide && img.label.toLowerCase().includes(label));

  const grid = [
    { image: getImage('right', 'macula'), label: 'OD (Right) Macula Centered' },
    { image: getImage('left', 'macula'), label: 'OS (Left) Macula Centered' },
    { image: getImage('right', 'optic'), label: 'OD (Right) Optic Disc Centered' },
    { image: getImage('left', 'optic'), label: 'OS (Left) Optic Disc Centered' },
  ];

  return (
    <div className="flex-1 pt-2">
      <div className="grid grid-cols-2 grid-rows-2 gap-2 h-full">
        {grid.map((cell) => (
          <div key={cell.label} className="flex flex-col min-h-0">
            <p className="text-[10px] text-gray-700 mb-0.5 shrink-0">{cell.label}</p>
            <div className="bg-black flex-1 flex items-center justify-center overflow-hidden min-h-0">
              {cell.image ? (
                <img
                  src={cell.image.s3_url}
                  alt={cell.label}
                  className="w-full h-full object-contain"
                  onLoad={onImageLoad}
                  onError={onImageLoad}
                />
              ) : (
                <span className="text-xs text-gray-400">No image</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
